module.exports = __webpack_public_path__ + "img/icon_investmezzanine_strong_02.ceacdf5e.svg";